import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import GallerySlider from '../components/GallerySlider';
import About from '../components/About';
import Clients from '../components/Clients';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import Features from '../components/Features';
import Stats from '../components/Stats';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';


const HomePage = () => {
    return (
        <div className="font-sans overflow-x-hidden">
            <Navbar />

            {/* Hero ke neeche baaki sections ke liye ek container */}
            <main>
                <Hero />

                {/* space-y-16 har section ke beech mein 64px ka gap dega */}
                <div className="space-y-16 py-10">
                    <Services />
                    <GallerySlider />
                    <About />
                    <Clients />
                    <WhyChooseUs />
                    <Testimonials />
                    <Features />
                    <Stats />
                    <FAQ />
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default HomePage;